import { atom } from "recoil";
import { ICameraType2 } from "../types";

export const addStateCameraType2 = atom({
  key: "addStateCameraType2",
  default: false,
});
export const editStateCameraType2 = atom({
  key: "editStateCameraType2",
  default: false,
});
export const rowEditCameraType2 = atom<ICameraType2 | undefined>({
  key: "rowEditCameraType2",
  default: undefined,
});

export const selectedRowsStateCameraType2 = atom<ICameraType2[]>({
  key: "selectedRowsStateCameraType2",
  default: [],
});

export const cameraType2FilterText = atom({
  key: "cameraType2FilterText",
  default: "",
});

export const cameraType2Fetching = atom({
  key: "cameraType2Fetching",
  default: true,
});

export const cameraType2ReFetching = atom({
  key: "cameraType2ReFetching",
  default: false,
});
